export const padWidth = '813px';
export const padWidthNum = 813;

export const phoneWidth = '480px';
export const phoneWidthNum = 480;
